import { EnumModuleType } from '@/src/types/common/module';
import { useDispatch } from 'react-redux';
import {
  generateCarousel,
  generateLongCanvas,
  //generateProductCarousel,
  generatePoster,
  generateProductGrid,
  generateProductList,
  generateResponsiveImageCarousel,
  generateResponsivePoster,
  generateResponsivePosterTab,
  generateResponsiveProductGrid,
  generateResponsiveSubscription,
  generateResponsiveTextEditor,
  generateSubscription,
  generateText,
  generateVideo,
} from 'src/constrains/DraggableModules/tools';
import { ActionType } from 'src/types/common/common';
import { WebSiteSubType } from 'src/types/common/SalesChannel';

const useGenerateModules = (currentStyle, moduleContentOnChange) => {
  const _d = useDispatch();
  if (currentStyle === WebSiteSubType.NativeMobile) {
    return [
      {
        type: EnumModuleType.Carousel,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateCarousel(1)[0],
            }),
          );
        },
      },
      {
        type: EnumModuleType.Poster,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generatePoster(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.LongCanvas,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateLongCanvas(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.Text,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateText(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.ProductGrid,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateProductGrid(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.ProductList,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateProductList(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.Subscription,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateSubscription(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.Video,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateVideo(),
            }),
          );
        },
      },
    ];
  } else {
    return [
      {
        type: EnumModuleType.ResponsiveSubscription,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateResponsiveSubscription(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.ResponsivePoster,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateResponsivePoster(),
            }),
          );
        },
      },

      {
        type: EnumModuleType.ResponsiveImageCarousel,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateResponsiveImageCarousel(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.ResponsiveProductGrid,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateResponsiveProductGrid(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.ResponsiveText,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateResponsiveTextEditor(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.ResponsivePosterTab,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateResponsivePosterTab(),
            }),
          );
        },
      },

      //  //
      //
    ];
  }
};
export { useGenerateModules };
